/***********************
 * INDEX TAB5 CONTENT 
 (Measurements)
 ************************/

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Col, Row } from "reactstrap"

// Importing components
import RemoteMeasurementsTable from "./RemoteMeasurementsTable"
import RemoteMeasurementsChart from "./RemoteMeasurementsChart"

// Locale
import { withTranslation } from "react-i18next"
import CardTableBtn from "../CardTableBtn"

const RMTabReporting = props => {
  // Filter view related states
  const [widgetVisible, setWidgetVisible] = useState(true)
  const [tableVisible, setTableVisible] = useState(false)
  // Passing customers data to cards/stats
  const [customers] = useState()
  // Set new state data when props.data changes
  useEffect(() => {
    // console.log("Measurement data changed: " + JSON.stringify(props.data))
  }, [props.data])

  return (
    <>
      {/* Setting filter for view */}
      <Row>
        <Col>
          <CardTableBtn
            widgetVisible={widgetVisible}
            tableVisible={tableVisible}
            setWidgetVisible={setWidgetVisible}
            setTableVisible={setTableVisible}
          />
          <div className="mt-2 mb-1">
            {widgetVisible && (
              <RemoteMeasurementsChart
                customers={customers}
                data={props.data}
                quickGuide={props.quickGuide}
              />
            )}
            {tableVisible && (
              <RemoteMeasurementsTable minRows={0} data={props.data} />
            )}
          </div>
        </Col>
      </Row>
    </>
  )
}

RMTabReporting.propTypes = {
  data: PropTypes.any,
  quickGuide: PropTypes.any,
}

export default withTranslation()(RMTabReporting)
